"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var settingTools = _interopRequireWildcard(require("@/libs/settingTools"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = {
  data: function data() {
    return {
      filterString: ''
    };
  },
  computed: {
    filteredSettings() {
      let settings = this.settings;
      let filter = this.filterString.toLowerCase();
      let out = [];
      Object.keys(settings).forEach(key => {
        let value = settings[key];
        if (value.key.toLowerCase().indexOf(filter) !== -1) {
          out.push(value);
        }
      });
      return out;
    },
    settings() {
      let out = {};
      let base = [];
      settingTools.buildTree(out, base, this.$state.getSetting('settings'), false);
      settingTools.buildTree(out, base, this.$state.getSetting('user_settings'), true);
      return _lodash.default.orderBy(Object.keys(out).map(key => out[key]), [o => o.key.split('.').length - 1, 'key'], ['asc']);
    }
  },
  methods: {
    resetValue(event, settingKey) {
      let newVal = this.$state.getSetting('settings.' + settingKey);
      if (!newVal) {
        newVal = null;
      }
      this.$state.setting(settingKey, newVal);
    },
    updateSetting(event, settingKey) {
      let target = event.target;
      let val = target.type === 'checkbox' ? target.checked : target.value;
      switch (target.type) {
        case 'checkbox':
          val = target.checked;
          break;
        case 'number':
          val = parseInt(target.value, 10);
          break;
        default:
          val = target.value;
          break;
      }
      if (this.$state.setting(settingKey) === val) {
        return;
      }
      this.$state.setting(settingKey, val);
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["SettingsAdvanced"]
window._app_exports.components.SettingsAdvanced = exports.default ? exports.default : exports;
